import * as three from 'three';

export class Particle {
  position: three.Vector2 = new three.Vector2(0, 0);
  velocity: three.Vector2 = new three.Vector2(0, 0);

  acceleration: three.Vector2 = new three.Vector2(0, 0);

  dragCoefficient: number = 0.8
}

export class Simulation {
  particles: Particle[] = [];


  tick() {
    for (const particle of this.particles) {
      particle.velocity.add(particle.acceleration);
      particle.position.add(particle.velocity);

      // apply drag
      if (particle.acceleration.length() === 0)
        particle.velocity.multiplyScalar(particle.dragCoefficient)
    }
  }
}